module.exports = __webpack_public_path__ + "img/img.ac9de76f.png";